import { render, staticRenderFns } from "./SfImage.vue?vue&type=template&id=5a25eb15&"
import script from "./SfImage.vue?vue&type=script&lang=js&"
export * from "./SfImage.vue?vue&type=script&lang=js&"
import style0 from "./SfImage.vue?vue&type=style&index=0&id=5a25eb15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports